import { SiLeetcode } from "react-icons/si";
import gfg from "../assets/gfg.png";

export const profiles = [
  {
    id: 1,
    name: "leetCode",
    href: "https://leetcode.com/Ayush01/",
    icon: <SiLeetcode size={40} color="black" />,
  },
  {
    id: 2,
    src: gfg,
    name: "gfg",
    href: "https://auth.geeksforgeeks.org/user/ayush123ngp/profile",
  },
];
